import { HttpHandler } from './HttpHandler';
import { environment } from '../enviroments';

export const patchUserAppLang = async (lang: string) => {
  await HttpHandler({
    method: 'PATCH',
    url: `${environment.LANGUAGES_URL}/change-app-locale/${lang}`,
  });

  return lang;
};
